import axios from 'axios';
import { API_URL } from '@/config';

export default {

  OutgoingGraph() {
    return axios.get(`${API_URL}/zabbix/graph/outgoing`);
  },

  IncomingGraph() {
    return axios.get(`${API_URL}/zabbix/graph/incoming`);
  },
};
